import script from "./DemographicsAnalytics.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemographicsAnalytics.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__